import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private http: HttpClient) { }

  download(fileType: number, path: string, fileName: string): Observable<any> {
    return this.http
      .get(environment.apiUrl + `/download/${fileType}/${path}`, {
        responseType: 'blob',
      })
      .pipe(
        map((response: any) => {
          return {
            filename: fileName,
            data: response,
          };
        })
      );
  }

  downloadUrl(fileType: number, path: string): string {
    return environment.apiUrl + `/download/${fileType}/${path}`;
  }

  directDownload(url: string) {
    window.open(url, '_blank');
  }
}
